// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_modal__ZCzBp {
    left: 50%;
    bottom: 5%;
    position: fixed;
    z-index: 1300;
    transition: transform 0.3s cubic-bezier(.4,0,.2,1);
    transform: translate(-50%, 200%);
}

.Profile_modalOpen__3Wh6u {
    transform: translate(-50%, 0);
}`, "",{"version":3,"sources":["webpack://./src/scenes/Profile.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,aAAa;IACb,kDAAkD;IAClD,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".modal {\n    left: 50%;\n    bottom: 5%;\n    position: fixed;\n    z-index: 1300;\n    transition: transform 0.3s cubic-bezier(.4,0,.2,1);\n    transform: translate(-50%, 200%);\n}\n\n.modalOpen {\n    transform: translate(-50%, 0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Profile_modal__ZCzBp`,
	"modalOpen": `Profile_modalOpen__3Wh6u`
};
export default ___CSS_LOADER_EXPORT___;
